import _ from "lodash";
import { graphql } from "lib/apolloClient";

// queries
import { getGradeScalesQuery } from "./AssessmentGradeScaleToolQueries";

// utils
import { getGradeScaleQueryVariables } from "./Utils";
import { getIsAssessmentGradeScaleToolEnabled } from "ClassRoom/modules/utils";

export const getGradeScalesQueryEnhancer = graphql(getGradeScalesQuery, {
  name: "getGradeScales",
  options: ({
    curriculumProgramId,
    assessmentId,
    learningCourseId,
    academicYearId,
    fetchPolicy = "cache-and-network",
    courseId,
  }) => {
    const variables = getGradeScaleQueryVariables({
      curriculumProgramId,
      assessmentId,
      learningCourseId,
      academicYearId,
      courseId,
    });

    return {
      fetchPolicy,
      variables,
    };
  },
  skip: ({
    curriculumProgramId,
    learningCourseId,
    assessmentId,
    academicYearId,
    courseId,
  }) => {
    const variables = getGradeScaleQueryVariables({
      curriculumProgramId,
      assessmentId,
      learningCourseId,
      academicYearId,
      courseId,
    });

    const entityDetailFilters = _.get(
      variables,
      "gradeScaleFilters.entityDetailFilters",
      []
    );

    return (
      !getIsAssessmentGradeScaleToolEnabled() ||
      _.isEmpty(entityDetailFilters) ||
      _.size(entityDetailFilters) > 1 ||
      (!learningCourseId && !curriculumProgramId)
    );
  },
  props({ getGradeScales: { node, networkStatus } }) {
    const gradeScalesNode = _.get(node, "gradeScale.edges");

    const gradeScales = _.map(gradeScalesNode, ({ node }) => {
      const { id, displayName, gradeScaleEntityDetails } = node;

      return {
        key: _.get(_.first(gradeScaleEntityDetails), "id"),
        label: displayName,
        gradeScaleId: id,
      };
    });

    const isData = !_.isEmpty(node);
    const isLoading = _.includes([1, 2], networkStatus);

    return {
      gradeScales,
      // in case of subject based grading this query gets triggered on subject change
      // returning isData and isLoading will trigger withLoader, and a full screen loader will be shown
      // which is unnecessary
      isGradeScaleLoading: isLoading && !isData,
    };
  },
});
